
import { createSlice } from "@reduxjs/toolkit";
import { getVentilation } from "./VentilitaionPageFetch";

const initialState = {
    isLoading: false,
    error: '',
    ventilationInfo: [],
}

const VentilationPageSlice = createSlice({
    name: 'ventilation',
    initialState,
    reducers:{},
    extraReducers:{
        [getVentilation.pending.type]: (state) => {
            state.isLoading = true
        },
        [getVentilation.fulfilled.type]:(state, action)=>{
            state.isLoading = false
            state.error = ''
            state.ventilationInfo = action.payload
        },
        [getVentilation.rejected.type]:(state, action)=>{
            state.isLoading = false
            state.error = action.payload
        }
    }
})

export const {} = VentilationPageSlice.actions

export default VentilationPageSlice.reducer
